import styled from 'styled-components';

interface IBreadcrumbsProps {
  color?: string;
}

export const Container = styled.div<IBreadcrumbsProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  position: relative;
  justify-content: flex-start;
  flex-direction: row;
  color: ${props => props.color || props.theme.colors.white};

  > a {
    display: flex;
    text-decoration: none;
    color: ${props => props.color || props.theme.colors.muted} !important;
    transition: all .2s ease-in-out;
    font-weight: 600;
    white-space: nowrap;

    > span {
      font-weight: 600;
    }

    &:hover {
      text-decoration: underline;
      color: ${props => props.theme.colors.white};
    }

    &:first-child {
      color: ${props => props.theme.colors.white};
    }
    
    &:last-child {
      color: ${props => props.theme.colors.white};
    }
  }

  span {
    padding: 0 0.5rem;
  }
`;
